export const ASOCIADO_PORTAFOLIO_GROUP_ID = '0b28121d-9803-4281-b957-a11d4d442bc9';

const ROLE_KEY = 'gw.userGroupId';

const ASSOCIATE_ALLOWED_PREFIXES = [
    '/portafolio-gei',
    '/portf-organization',
    '/change-password',
    '/results',
    '/activity',
    '/establishment/gei',
];

export function rememberRole(role: string | null | undefined): void {
    if (!role) {
        localStorage.removeItem(ROLE_KEY);
        return;
    }
    localStorage.setItem(ROLE_KEY, role);
}

export function readRememberedRole(): string | null {
    return localStorage.getItem(ROLE_KEY);
}

export function clearRememberedRole(): void {
    localStorage.removeItem(ROLE_KEY);
}

export function isPortfolioAssociate(role: string | null | undefined): boolean {
    return (role || '').toLowerCase() === ASOCIADO_PORTAFOLIO_GROUP_ID;
}

export function associateRouteDecision(
    role: string | null | undefined,
    pathname: string
): 'allow' | 'deny' | 'unknown' {
    if (!role) {
        return 'unknown';
    }
    if (!isPortfolioAssociate(role)) {
        return 'allow';
    }
    const path = (pathname || '/').split('?')[0];
    const allowed = ASSOCIATE_ALLOWED_PREFIXES.some(
        (prefix) => path === prefix || path.startsWith(`${prefix}/`)
    );
    return allowed ? 'allow' : 'deny';
}

export function selectPostLoginPath(
    role: string | null | undefined,
    modules: Array<{ link?: string | null }> | null | undefined
): string {
    if (isPortfolioAssociate(role)) {
        return '/portafolio-gei';
    }
    const list = Array.isArray(modules) ? modules : [];
    const first = list.find((module) => typeof module?.link === 'string' && module.link.trim().length > 0);
    if (!first?.link) {
        return '/welcome';
    }
    return `/${first.link.trim().replace(/^\/+/, '')}`;
}
